<template>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
import { useChatStore } from "./stores/chat";
import { useUserStore } from "./stores/user";

const chatStore = useChatStore();
const userStore = useUserStore();

// Load initial data when app mounts (only if user is authenticated)
onMounted(() => {
  if (userStore.isAuthenticated) {
    chatStore.loadChats();
  }
});
</script>
